import { Center, Flex, Text } from '@chakra-ui/react';
import { PeOrderOperationType } from 'enums/modules/pe/peOperationType';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import PeDetailAssetCard from './PeDetailAssetCard';

interface Props {
  company: PeCompanyDetail;
}

const PeDetailAssets: FC<Props> = ({ company }) => {
  const gapBetweenCards = 20;

  const navigate = useNavigate();

  const { t } = useTranslation();

  if (company.assets.length === 0) {
    return (
      <AppCard p="20px">
        <Center>
          <Text>{t('listIsEmpty')}</Text>
        </Center>
      </AppCard>
    );
  }

  return (
    <Flex flexWrap="wrap" justifyContent="space-between">
      {company.assets.map((asset, index) => (
        <PeDetailAssetCard
          key={index}
          w={`calc(50% - ${gapBetweenCards / 2}px)`}
          mb={`${gapBetweenCards}px}`}
          onSellClick={() => {
            navigate(AppRoute.createPeCompanyOrder(company.id, {
              company_name: company.name,
              company_currency: company.currency.symbol,
              operation_type: PeOrderOperationType.Sell,
              quantity: asset.quantity,
            }));
          }}
          asset={asset}
          currency={company.currency}
        />
      ))}
    </Flex>
  );
};

export default PeDetailAssets;
